/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const FilePenSolidFull = props => (
  <svg viewBox="0 0 640 640" width="1em" height="1em" {...props}>
    <path d="M128.1 64c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h146.2l10.9-54.5c4.3-21.7 15-41.6 30.6-57.2L448 332.1v-97.5c0-17-6.7-33.3-18.7-45.3L322.8 82.7c-12-12-28.3-18.7-45.2-18.7H128.1zm261.5 176h-93.5c-13.3 0-24-10.7-24-24v-93.5L389.6 240zm-57.3 290.9l-11.9 59.6c-.2.9-.3 1.9-.3 2.9 0 8 6.5 14.6 14.6 14.6 1 0 1.9-.1 2.9-.3l59.6-11.9c12.4-2.5 23.8-8.6 32.7-17.5l118.9-118.9-80-80-118.9 118.9c-8.9 8.9-15 20.3-17.5 32.7zm267.8-123c22.1-22.1 22.1-57.9 0-80s-57.9-22.1-80 0l-28.8 28.8 80 80 28.8-28.8z" />
  </svg>
);
export default extendIcon(FilePenSolidFull);

